import { render, staticRenderFns } from "./TenderCardOffers.vue?vue&type=template&id=39d037dd&"
import script from "./TenderCardOffers.vue?vue&type=script&lang=js&"
export * from "./TenderCardOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports